
export enum AlertTriggerCriteria {
	LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
	GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
	INCREASE_GREATER_OR_EQUAL = 'INCREASE_GREATER_OR_EQUAL',
	DECREASE_GREATER_OR_EQUAL = 'DECREASE_GREATER_OR_EQUAL',
	CHANGE_GREATER_OR_EQUAL = 'CHANGE_GREATER_OR_EQUAL',
	SIGNIFICANT_CHANGE = 'SIGNIFICANT_CHANGE'
}
